import Wizard from "./wizard";

export default Wizard;
